export const errorAndSuccessSounds = {
	methods: {
		playSuccessSound() {
			var audio = new Audio(require('../assets/audio/success.mp3'));
			audio.play();
		},
		playErrorSound() {
			var audio = new Audio(require('../assets/audio/error.wav'));
			audio.play();
		}
	}
};
